import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button", "eye", "eyeOff"];

  // Turbo can restore a cached page with the field still revealed, so re-mask on connect.
  connect() {
    this.reveal(false);
  }

  toggle() {
    this.reveal(this.inputTarget.type === "password");
  }

  reveal(revealed) {
    this.inputTarget.type = revealed ? "text" : "password";
    this.eyeTarget.classList.toggle("hidden", revealed);
    this.eyeOffTarget.classList.toggle("hidden", !revealed);
    this.buttonTarget.setAttribute("aria-label", revealed ? "Hide password" : "Show password");
  }
}
